module.exports = require("/Users/sumisonic/Repositories/gitlab.rzm.co.jp/sumito-rzm/senseisland_2021/gatsby/gatsby-browser.ts");